export default "module.exports = (async () => {\n  const alice = await loadIdentity(key);\n  await channel\n\n  return 'invitation for alice';\n})();"